/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The origin of the auth support:
 *   * API
 *   * TRANSACTION
 *   * IMPORT
 *   * MANUAL
 */
export enum AuthSupportOrigin {
  API = 'API',
  TRANSACTION = 'TRANSACTION',
  IMPORT = 'IMPORT',
  MANUAL = 'MANUAL'
}
